import React, { useState } from "react";
import TeamContext from "../../../contexts/TeamContext";
import Table from "./Table";

export default function Index({ enterpriseId }) {
  return (
    <TeamContext enterpriseId={enterpriseId}>
      <Table />
    </TeamContext>
  );
}
